import React, { useState, useEffect, useRef } from 'react';

import {
  Root,
  MissionSection,
  HildeshaimSection,
  ExpertiseSection,
  TechnologySection,
  TeamSection,
  RelationshipsSection,
  CPASection,
  OurClientsSection,
  lastSection,
  motifator,
  OuterCLientsSection,
} from '../components/aboutUs/styles';
import {
  DarthFader,
  FivePlus,
  GreenQuoteIcon,
  HugeRings,
  MobileCircle,
  SideMotif,
  SinglePlus,
  TargetSites,
  ThingIcon,
  ThingThreeIcon,
  ThingTwoIcon,
  ThreePlus,
  ThreePlusVertical,
  HugeRingsTwo,
  ThingFourIcon,
  ExpertiseMotif,
  CompleteCircles,
  InCompleteCircles,
  MotifMotive,
  ThreeVertical,
  DoubleTrouble,
  AndYetAnotherThreePlusGroup,
} from '../components/aboutUs/svg';
import { useInView } from '../components/aboutUs/useinview';

import { details } from '../components/aboutUs/text';
import LastSection from '../components/home/LastSection';

export default function OurMission() {
  const [oneIsOpen, setOneIsOpen] = useState(false);
  const [twoIsOpen, setTwoIsOpen] = useState(false);
  const [threeIsOpen, setThreeIsOpen] = useState(false);
  const [fourIsOpen, setFourIsOpen] = useState(false);
  const [fiveIsOpen, setFiveIsOpen] = useState(false);
  const [sixIsOpen, setSixIsOpen] = useState(false);
  const [sevenIsOpen, setSevenIsOpen] = useState(false);

  const [ref, inView] = useInView();
  const [ref2, inView2] = useInView();
  const [ref3, inView3] = useInView();
  const [ref4, inView4] = useInView();
  const [ref5, inView5] = useInView();
  const [ref6, inView6] = useInView();
  const [ref7, inView7] = useInView();
  // const [ref8, inView8] = useInView();

  return (
    <>
      <Root>
        <MissionSection ref={ref} className={inView ? 'fade-in-up' : 'hidden-before-scroll'}>
          <h1 className='blueHeader'>Our Mission</h1>
          <MobileCircle className='mobile-circles' />
          <GreenQuoteIcon className='green-quote-icon' />
          <HugeRings className='huge-rings' />
          <HugeRingsTwo className='huge-rings-two' />
          {/* <img
          src='https://res.cloudinary.com/dyuuf6gor/image/upload/v1751044252/specs/green-quote_gghwe4.svg'
          alt=''
        /> */}
          <p className='blueSubHeader'>
            Through building Madison SPECS, I'm working to build access to high-quality cost
            segregation for all.
          </p>
          <div className='nameAndTitle'>
            <p>Eli Loebenbeg</p>
            <p>CEO</p>
          </div>
          <div className='flexer'>
            <img
              src='https://res.cloudinary.com/dyuuf6gor/image/upload/f_auto,q_auto/specs/elilowthree_wqr1so.png'
              alt='Founder'
              className='founder-image'
            />
            <div className='mobile-text'>
              <div>
                {oneIsOpen ? (
                  <>
                    <p>{details[0].textOne}</p>
                    <p>{details[0].textTwo}</p>
                  </>
                ) : (
                  'Every real estate investor should have access to the highest-level cost segregation ser...'
                )}
                {!oneIsOpen && (
                  <span className='readMore' onClick={() => setOneIsOpen(true)}>
                    Read More
                  </span>
                )}
              </div>
            </div>
            <div className='sectionText'>
              <p>{details[0].textOne}</p>
              <p>{details[0].textTwo}</p>
            </div>
          </div>
          <ThingIcon className='thing-icon' />
          <ThingTwoIcon className='thing-two-icon' />
          <ThingThreeIcon className='thing-three-icon' />
        </MissionSection>

        <HildeshaimSection ref={ref2} className={inView2 ? 'fade-in-up' : 'hidden-before-scroll'}>
          <GreenQuoteIcon className='green-quote-icon' />
          <p className='blueSubHeader'>
            Our clients are our everything, and my goal is for them to be thrilled with our work.
          </p>
          <div className='nameAndTitle'>
            <p>Moshe Hildeshaim</p>
            <p>COO</p>
          </div>
          <div className='flexer'>
            <img
              src='https://res.cloudinary.com/dyuuf6gor/image/upload/f_auto,q_auto/specs/mo-hild_k1rp7x.png'
              alt='Client'
              className='client-image'
            />
            <div className='mobile-text'>
              <div>
                {twoIsOpen ? (
                  <>
                    <p>{details[1].textOne}</p>
                    <p>{details[1].textTwo}</p>
                  </>
                ) : (
                  'Over our 18-year history, we have not stopped listening to our clients and respondin... '
                )}
                {!twoIsOpen && (
                  <span className='readMore' onClick={() => setTwoIsOpen(true)}>
                    Read More
                  </span>
                )}
              </div>
            </div>
            <div className='sectionText'>
              <p>{details[1].textOne}</p>
              <p>{details[1].textTwo}</p>
            </div>
          </div>
          <ThingIcon className='thing-icon' />
          <ThingTwoIcon className='thing-two-icon' />
          <ThingThreeIcon className='thing-three-icon' />
        </HildeshaimSection>
        <div className='gradientBackground gradientBackgroundExpertise'>
          <ExpertiseSection ref={ref3} className={inView3 ? 'fade-in-up' : 'hidden-before-scroll'}>
            <ThreePlus className='three-plus' />
            <ThingFourIcon className='thing-four-icon' />
            <ExpertiseMotif className='expertise-motif' />
            <h2 className='blueHeader'>Expertise</h2>
            <div className='flexer'>
              <div className='sectionOne'>
                <GreenQuoteIcon className='green-quote-icon' />
                <p className='blueSubHeader'>
                  No detail is too small when it comes to finding depreciable assets for our
                  clients.
                </p>
                <div className='nameAndTitle'>
                  <p>Ephraim Baruch</p>
                  <p>Cost Segregation Expert</p>
                </div>
              </div>
              <img
                // src='https://res.cloudinary.com/dyuuf6gor/image/upload/f_auto,q_auto/specs/ephr-bar_vei5bh.png'
                src='https://res.cloudinary.com/dyuuf6gor/image/upload/f_auto,q_auto/specs/eb-expertise_e70yny.png'
                alt='Expertise'
                className='sectionTwo'
              />
              <div className='mobile-text'>
                <div>
                  {threeIsOpen ? (
                    <>
                      <p>{details[2].textOne}</p>
                      <p>{details[2].textTwo}</p>
                    </>
                  ) : (
                    'Clients are always curious what exactly we do when examining a property. Once... '
                  )}
                  {!threeIsOpen && (
                    <span className='readMore' onClick={() => setThreeIsOpen(true)}>
                      Read More
                    </span>
                  )}
                </div>
              </div>
              <div className='sectionText'>
                <p>{details[2].textOne}</p>
                <p>{details[2].textTwo}</p>
              </div>
            </div>
            <ThingIcon className='thing-icon' />
            <ThingTwoIcon className='thing-two-icon' />
            <ThingThreeIcon className='thing-three-icon' />
          </ExpertiseSection>

          <TechnologySection ref={ref4} className={inView4 ? 'fade-in-up' : 'hidden-before-scroll'}>
            <h2 className='blueHeader'>Technology</h2>
            <div className='flexer'>
              <div className='sectionOne'>
                <GreenQuoteIcon className='green-quote-icon' />
                <p className='blueSubHeader'>
                  We're building the technology that's keeping us on top of our game and ahead of
                  the curve.
                </p>
                <div className='nameAndTitle'>
                  <p>Sruly Davidowitz</p>
                  <p>Product Lead</p>
                </div>
              </div>
              <img
                src='https://res.cloudinary.com/dyuuf6gor/image/upload/f_auto,q_auto/specs/sdavid_j9htkn.png'
                alt='Technology'
                className='sectionTwo'
              />
              <div className='mobile-text'>
                <div>
                  {fourIsOpen ? (
                    <>
                      <p>{details[3].textOne}</p>
                    </>
                  ) : (
                    'When dealing with a service that intersects engineering, accounting and relation...'
                  )}
                  {!fourIsOpen && (
                    <span className='readMore' onClick={() => setFourIsOpen(true)}>
                      Read More
                    </span>
                  )}
                </div>
              </div>
              <div className='sectionText'>
                <p>{details[3].textOne}</p>
              </div>
            </div>
            <ThingIcon className='thing-icon' />
            <ThingTwoIcon className='thing-two-icon' />
            <ThingThreeIcon className='thing-three-icon' />
          </TechnologySection>
        </div>
        <div className='gradientBackground gradientBackgroundTeam'>
          {/* <InCompleteCircles className='incomplete-circles' /> */}
          <CompleteCircles className='incomplete-circles' />
          {/* <ExpertiseMotif className='motif-motive' /> */}
          {/* <MotifMotive className='motif-motive' /> */}
          <img
            src='https://res.cloudinary.com/dyuuf6gor/image/upload/f_auto,q_auto/specs/csdcsdc_kp419n.png'
            alt='motif design'
            className='motif-motive'
          />
          <TeamSection ref={ref5} className={inView5 ? 'fade-in-up' : 'hidden-before-scroll'}>
            <FivePlus className='five-plus' />
            <h2 className='blueHeader'>Team</h2>
            <GreenQuoteIcon className='green-quote-icon' />
            <p className='blueSubHeader'>
              Through building Madison SPECS, I'm working to build access to high-quality cost
              segregation for all.
            </p>
            <div className='nameAndTitle'>
              <p>Tziviah Waidenbaum</p>
              <p>Director of HR</p>
            </div>
            <div className='sectionText'>
              <p>{details[4].textOne}</p>
            </div>
            <div className='flexer'>
              <img
                src='https://res.cloudinary.com/dyuuf6gor/image/upload/f_auto,q_auto/specs/group-meeting_tgyvx6.png'
                alt='Team'
                className='team-image'
              />
              <div className='mobile-text'>
                <div>
                  {fiveIsOpen ? (
                    <p>{details[4].textOne}</p>
                  ) : (
                    'It is our great people who have built this company and given us such a respected name...'
                  )}
                  {!fiveIsOpen && (
                    <span className='readMore' onClick={() => setFiveIsOpen(true)}>
                      Read More
                    </span>
                  )}
                </div>
              </div>
            </div>
            <ThingIcon className='thing-icon' />
            <ThingTwoIcon className='thing-two-icon' />
            <ThingThreeIcon className='thing-three-icon' />
            {/* <SideMotif className='side-motif' /> */}
          </TeamSection>

          <RelationshipsSection
            ref={ref6}
            className={inView6 ? 'fade-in-up' : 'hidden-before-scroll'}
          >
            <TargetSites className='targetsites' />
            <CompleteCircles className='complete_circles' />
            <h2 className='blueHeader'>Relationships</h2>
            <div className='flexer'>
              <div className='sectionOne'>
                <GreenQuoteIcon className='green-quote-icon' />
                <p className='blueSubHeader'>
                  Our reps hate being called salespeople. We're relationship builders. And really
                  good ones, I might add.
                </p>
                <div className='nameAndTitle'>
                  <p>Yitz Goldman</p>
                  <p>Business Development Rep</p>
                </div>
              </div>
              <img
                src='https://res.cloudinary.com/dyuuf6gor/image/upload/f_auto,q_auto/specs/goldman-illus-1_yr74ob.png'
                alt='Relationships'
                className='sectionTwo'
              />
              <div className='mobile-text'>
                <div>
                  {sixIsOpen ? (
                    <>
                      <p>{details[5].textOne}</p>
                      <p>{details[5].textTwo}</p>
                    </>
                  ) : (
                    `Our business development reps love working for SPECS because they don't have to se...`
                  )}
                  {!oneIsOpen && (
                    <span className='readMore' onClick={() => setSixIsOpen(true)}>
                      Read More
                    </span>
                  )}
                </div>
              </div>
              <div className='sectionText'>
                <p>{details[5].textOne}</p>
                <p>{details[5].textTwo}</p>
              </div>
              <SinglePlus className='single-one' />
              <SinglePlus className='single-two' />
              <SinglePlus className='single-three' />
            </div>
            <ThingIcon className='thing-icon' />
            <ThingTwoIcon className='thing-two-icon' />
            <ThingThreeIcon className='thing-three-icon' />
          </RelationshipsSection>
        </div>
        <CPASection ref={ref7} className={inView7 ? 'fade-in-up' : 'hidden-before-scroll'}>
          <div style={{ textAlign: 'center' }}>
            <h2 className='blueHeader'>
              <SinglePlus className='single-one' />
              <SinglePlus className='single-two' />
              <SinglePlus className='single-three' />
              CPAs
            </h2>
          </div>
          <div className='flexer'>
            <div className='sectionOne'>
              <GreenQuoteIcon className='green-quote-icon' />
              <p className='blueSubHeader'>
                Our CPA relationships appreciate that we talk their language. We deal with them like
                partners and they love working with us.
              </p>
              <div className='nameAndTitle'>
                <p>Chuck Tover</p>
                <p>Tax Director</p>
              </div>
            </div>
            <img
              src='https://res.cloudinary.com/dyuuf6gor/image/upload/f_auto,q_auto/specs/cpa-chair_hwarzd.png'
              alt='CPAs'
              className='sectionTwo'
            />
            <div className='mobile-text'>
              <div>
                {sevenIsOpen ? (
                  <p>{details[6].textOne}</p>
                ) : (
                  `There's nothing better than talking with an accountant and seeing the trust build...`
                )}
                {!sevenIsOpen && (
                  <span className='readMore' onClick={() => setSevenIsOpen(true)}>
                    Read More
                  </span>
                )}
              </div>
            </div>
            <div className='sectionText'>
              <p>{details[6].textOne}</p>
            </div>
          </div>
          <ThingIcon className='thing-icon' />
          <ThingTwoIcon className='thing-two-icon' />
          <ThingThreeIcon className='thing-three-icon' />
        </CPASection>

        <OuterCLientsSection>
          <OurClientsSection>
            <ThreePlusVertical className='three-plus' />
            <SinglePlus className='single-one' />
            <SinglePlus className='single-two' />
            <SinglePlus className='single-three' />
            <DarthFader className='darth-fader' />
            <ThreeVertical className='threeVertical' />
            <DoubleTrouble className='doubleTrouble' />
            <AndYetAnotherThreePlusGroup className='andYetAnotherThreePlusGroup' />
            <h2 className='blueHeader'>Our Clients</h2>
            <GreenQuoteIcon className='green-quote-icon' />
            <p className='blueSubHeader'>
              Everyone on the team, no matter their role, walks in each day with the same goal:
              <br />
              How can we serve our clients better today?
            </p>
            <div className='sectionText'>
              <p>{details[7].textOne}</p>
              <p>{details[7].textTwo}</p>
            </div>
            <ThingIcon className='thing-icon' />
            <ThingTwoIcon className='thing-two-icon' />
          </OurClientsSection>
        </OuterCLientsSection>
      </Root>
      <LastSection overRides={lastSection} motifOverRides={motifator} />
    </>
  );
}
